import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"
import Sortable from "@stimulus-components/sortable"
import AutoSubmit from "@stimulus-components/auto-submit"
import ReadMore from "@stimulus-components/read-more"

const application = Application.start()
const controllers = import.meta.glob("./**/*_controller.js", { eager: true })

registerControllers(application, controllers)
application.register("sortable", Sortable)
application.register("auto-submit", AutoSubmit)
application.register("read-more", ReadMore)

function registerPhlexControllers() {
  const controllers = import.meta.glob(
    [
      "./../../views/**/controller.js",
      "./../../../packs/**/app/views/**/controller.js",
      "./../../../packs/**/app/components/**/controller.js",
    ],
    { eager: true }
  )

  for (let path in controllers) {
    let module = controllers[path]

    let packComponent = path.match(
      /packs\/([\w-]+)\/app\/components\/(.+)\/controller\.js$/
    )
    let name = packComponent
      ? `${packComponent[1]}--${packComponent[2]}`
      : path.match(/views\/(.+)\/controller\.js$/)[1]

    name = name
      .replaceAll("_", "-")
      .replaceAll("/", "--")
      .replace(/components--/g, "")

    if (module.Controller == undefined) {
      throw new Error(
        `Default class was exported, and controller is undefined.
        Please export a named controller. Path: ${path}.`
      )
    }

    application.register(name, module.Controller)
  }
}

registerPhlexControllers()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export { application }
